import { createI18n } from "vue-i18n";

const messages = {
  zh: {
    nav: {
      home: "Home",
      builder: "Builder",
      results: "Results",
      help: "Help",
      about: "About",
      newBuild: "+ 新建构建",
    },
    home: {
      kicker: "WORKFLOW STORE",
      title: "预设仓库",
      subtitle: "编辑推荐 • 热门预设 • 随机发现 • 检索 • LLM生成预设",
      refresh: "换一批",
      goBatch: "去批量构建",
      featured: "FEATURED",
      viewApply: "查看 / 应用",
      copyCode: "复制分享码",
      llmTitle: "LLM 生成预设（测试）",
      llmSubtitle: "预设模块结合第三方生成式大语言模型实现：自然语言 → JSON / 分享码",
      llmDemo: "示例",
      llmGen: "生成",
      llmCancel: "取消",
      trending: "Trending",
      trendingSub: "大家最近常用的流程骨架（无图，重内容与层级）",
      recommended: "Recommended",
      recommendedSub: "随机发现 + 编辑补位（无图）",
      quickApply: "Quick Apply",
      quickApplySub: "粘贴分享码 / 输入名称（一键应用）",
      apply: "应用",
      search: "Search",
      searchSub: "按标题/摘要/软件名/输入键检索预设（本地演示；后续可换后端搜索）",
      clear: "清空",
      openFirst: "打开第一个结果",
      empty: "没找到匹配的预设。试试更短的关键词（如：bwa / star / fq1）。",
    },
  },
  en: {
    nav: {
      home: "Home",
      builder: "Builder",
      results: "Results",
      help: "Help",
      about: "About",
      newBuild: "+ New Build",
    },
    home: {
      kicker: "WORKFLOW STORE",
      title: "Pipeline Repository",
      subtitle: "Editor picks • Trending • Random • Search • LLM-generated Pipeline",
      refresh: "Refresh",
      goBatch: "Go to Batch Builder",
      featured: "FEATURED",
      viewApply: "View / Apply",
      copyCode: "Copy share code",
      llmTitle: "LLM-Generated Preset (Experimental)",
      llmSubtitle: "The preset module integrates third-party generative large language models to enable natural language → JSON / share code generation.",
      llmDemo: "Demo",
      llmGen: "Generate",
      llmCancel: "Cancel",
      trending: "Trending",
      trendingSub: "Popular workflow skeletons (text-first, no images)",
      recommended: "Recommended",
      recommendedSub: "Random discovery + editor picks (text-first)",
      quickApply: "Quick Apply",
      quickApplySub: "Paste Share Code / Enter Name (Apply with One Click)",
      apply: "Apply",
      search: "Search",
      searchSub: "Search by title/summary/software/input keys (demo; can be backend-powered)",
      clear: "Clear",
      openFirst: "Open first result",
      empty: "No matching presets. Try shorter keywords (e.g., bwa / star / fq1).",
    },
  },
};

export const i18n = createI18n({
  legacy: false,
  locale: localStorage.getItem("lang") || "en",
  fallbackLocale: "en",
  messages,
});

